import { useQuery } from '@tanstack/react-query'
import { wollemAgentApi } from '../api'

const USE_USAGE_QUERY_KEY = 'get-usage'

export const useUsage = () => {
  return useQuery({
    queryKey: [USE_USAGE_QUERY_KEY],
    queryFn: wollemAgentApi.getUsage,
  })
}
